import { CheckmarkCircle } from "assets/Imports";
import "./PercentageBar.scss";
import { CustomSpinner } from "@components/Spinner/SpinnerMyAccountView";

interface PercentageI {
	percentage: any;
	ViewPercentage?: boolean;
	loading?: boolean;
}
function PercentageBar({ percentage, ViewPercentage = true, loading = false }: PercentageI) {
	if (loading) {
		return (
			<div className="percentage-bar-container loading">
				<CustomSpinner height={30} borderSize={4} size={30} />
			</div>
		);
	}

	return (
		<div className="percentage-bar-container">
			{percentage === 100 && <img src={CheckmarkCircle} alt="palomita de completado" />}
			{ViewPercentage ? (
				<h3 style={percentage === 100 ? { color: "#ca5050" } : {}}>{Math.floor(percentage)}%</h3>
			) : null}
			<div className="bar-container">
				<div
					className={"bar-progress " + (percentage === 100 ? "gold-bar" : "")}
					style={{ width: percentage + "%" }}
				>
					<div className="point-progress"></div>
				</div>
			</div>
		</div>
	);
}

export default PercentageBar;
